// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"I4-z","colorTextValue":"J4-z","swatches":"K4-z","collapseLink":"L4-z","isCollapsed":"M4-z","dropdown":"N4-z","disabled":"O4-z"};